import { Instance, types } from 'mobx-state-tree';

export const NewsletterListElementModel = types
  .model({
    id: types.number,
    url: types.string,
    name: types.string,
    status: types.number,
    showEveryTime: types.number,
    dateStart: types.string,
    dateEnd: types.string,
    updatedBy: types.maybeNull(types.string),
    createdBy: types.string,
    createdAt: types.string,
    updatedAt: types.string,
  })
  .views((_) => {
    return {};
  })
  .actions((_) => {
    return {};
  })
  .named('NewsletterListElementModel');

export type NewsletterListElementModelType = Instance<
  typeof NewsletterListElementModel
>;
